export default "__VITE_ASSET__B1EDBJ$K__"